<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y3tltt/tc-custom/9781911096900.jpg?1704515997121" alt="This image is the cover for the book Stout Hearts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stout Hearts
      </h1>
      <p class="bookDescription body article font2">
        <b>“At last a book has been written that forensically examines how the British Armed Forces fought its way through Normandy . . . utterly absorbing.” —James Holland, bestselling author of <i>Brothers in Arms</i></b><br/><br/><i>Stout Hearts</i> is a book which offers an entirely new perspective on the British Army in Normandy. This fresh study explores the anatomy of war through the Army’s operations in the summer of 1944, informing and entertaining the general nonfiction reader as well as students of military history. There have been so many books written on Normandy that the publication of another one might appear superfluous. However most books have focused on narrating the conduct of the battle, describing the factors that influenced its outcome, or debating the relative merits of the armies and their generals. What was missing from the existing body of work on Normandy specifically and the Second World War generally is a book that explains how an army actually operates in war and what it was like for those involved; <i>Stout Hearts</i> fills this gap.<br/><br/><i>Stout Hearts</i> is essential reading for those who wish to understand the “mechanics” of battle. How does an Army care for its wounded? How do combat engineers cross obstacles? How do tanks fight? How do Air and Naval Forces support the Army? But to understand what makes an Army “tick” you must also understand its people. Therefore explanations of tactics and techniques are not only well illustrated with excellent photographs and high quality maps but also effectively combined with relevant accounts from the combatants themselves. These dramatic stories of ordinary people doing extraordinary things are the strength of the book, bringing the campaign to life and entertaining the reader.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ben Kite
      </h2>
      
      <p class="authorDescription body article">Ben Kite is a serving senior British Army Officer. He has served in a variety of different roles in his thirty year Army career including deployments to Belize, Bosnia, Kurdistan, South Africa, Kosovo, Iraq and Afghanistan. His service included operational roles with Royal Marine and Royal Air Force Units. Ben Kite has instructed at the Royal Military Academy Sandhurst and is a graduate of the Higher Command and Staff Course. He is a Fellow of the Royal Historical Society and the British Commission for Military History. He is the author of the best-selling Stout Hearts -The British and Canadians in Normandy 1944, published in 2014 to wide acclaim.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Helion and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?527e5cb4